import {
  ENGINEERING_SYSTEMS_CDN_PATH,
  ENGINEERING_SYSTEMS_LANDING_NAME,
} from '../../../engineering-systems-constants';
import { GalleryListStructure } from '../../../components';

export const POWER_SUPPLY_GALLERY_LIST: GalleryListStructure[] = [
  {
    src: `${ENGINEERING_SYSTEMS_LANDING_NAME}/electric/popup/1.jpg/1.jpg`,
    srcThumb: `${ENGINEERING_SYSTEMS_CDN_PATH}/electric/electric-1b.jpg/electric-1b.jpg`,
    srcSmall: `${ENGINEERING_SYSTEMS_CDN_PATH}/electric/electric-1b.jpg/electric-1b.jpg`,
    alt: 'Пример установки системы электроснабжения',
    name: '1.jpg',
  },
  {
    src: `${ENGINEERING_SYSTEMS_LANDING_NAME}/electric/popup/2.jpg/2.jpg`,
    srcThumb: `${ENGINEERING_SYSTEMS_CDN_PATH}/electric/electric-2b.jpg/electric-2b.jpg`,
    srcSmall: `${ENGINEERING_SYSTEMS_CDN_PATH}/electric/electric-2b.jpg/electric-2b.jpg`,
    alt: 'Пример установки системы электроснабжения',
    name: '2.jpg',
  },
  {
    src: `${ENGINEERING_SYSTEMS_LANDING_NAME}/electric/popup/3.jpg/3.jpg`,
    srcThumb: `${ENGINEERING_SYSTEMS_CDN_PATH}/electric/electric-3b.jpg/electric-3b.jpg`,
    srcSmall: `${ENGINEERING_SYSTEMS_CDN_PATH}/electric/electric-3b.jpg/electric-3b.jpg`,
    alt: 'Пример установки системы электроснабжения',
    name: '3.jpg',
  },
  {
    src: `${ENGINEERING_SYSTEMS_LANDING_NAME}/electric/popup/4.jpg/4.jpg`,
    srcThumb: `${ENGINEERING_SYSTEMS_CDN_PATH}/electric/electric-4b.jpg/electric-4b.jpg`,
    srcSmall: `${ENGINEERING_SYSTEMS_CDN_PATH}/electric/electric-4b.jpg/electric-4b.jpg`,
    alt: 'Пример установки системы электроснабжения',
    name: '4.jpg',
  },
  {
    src: `${ENGINEERING_SYSTEMS_LANDING_NAME}/electric/popup/5.jpg/5.jpg`,
    srcThumb: `${ENGINEERING_SYSTEMS_CDN_PATH}/electric/electric-5b.jpg/electric-5b.jpg`,
    srcSmall: `${ENGINEERING_SYSTEMS_CDN_PATH}/electric/electric-5b.jpg/electric-5b.jpg`,
    alt: 'Пример установки системы электроснабжения',
    name: '5.jpg',
  },
  {
    src: `${ENGINEERING_SYSTEMS_LANDING_NAME}/electric/popup/6.jpg/6.jpg`,
    srcThumb: `${ENGINEERING_SYSTEMS_CDN_PATH}/electric/electric-6b.jpg/electric-6b.jpg`,
    srcSmall: `${ENGINEERING_SYSTEMS_CDN_PATH}/electric/electric-6b.jpg/electric-6b.jpg`,
    alt: 'Пример установки системы электроснабжения',
    name: '6.jpg',
  },
  {
    src: `${ENGINEERING_SYSTEMS_LANDING_NAME}/electric/popup/7.jpg/7.jpg`,
    srcThumb: `${ENGINEERING_SYSTEMS_CDN_PATH}/electric/electric-7b.jpg/electric-7b.jpg`,
    srcSmall: `${ENGINEERING_SYSTEMS_CDN_PATH}/electric/electric-7b.jpg/electric-7b.jpg`,
    alt: 'Пример установки системы электроснабжения',
    name: '7.jpg',
  },
  {
    src: `${ENGINEERING_SYSTEMS_LANDING_NAME}/electric/popup/8.jpg/8.jpg`,
    srcThumb: `${ENGINEERING_SYSTEMS_CDN_PATH}/electric/electric-8b.jpg/electric-8b.jpg`,
    srcSmall: `${ENGINEERING_SYSTEMS_CDN_PATH}/electric/electric-8b.jpg/electric-8b.jpg`,
    alt: 'Пример установки системы электроснабжения',
    name: '8.jpg',
  },
];
